import { useMessageUnreadSummary } from "../../../hooks/api/v2/message/useMessageUnreadSummary";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { NavigationActivityOverlay } from "./NavigationActivityOverlay";
import { DIRECT_MESSAGE_LIST } from "../../../constants/routes";
import { useNavigationOverlay } from "./NavigationOverlayContext.shared";
import { MessagesNavigationContent } from "./MessagesNavigationContent";

export const MessagesNavigationOverlay = () => {
  const summary = useMessageUnreadSummary();
  const { business } = useSellarCurrentBusiness();
  const hasUnread =
    !!business?.BusinessUser &&
    !summary.isError &&
    (summary.data?.unreadCount ?? 0) > 0;
  const { closeOverlay } = useNavigationOverlay();
  return (
    <NavigationActivityOverlay
      id="messages"
      title="Messages"
      icon="MESSAGE_OUTLINE"
      href={DIRECT_MESSAGE_LIST}
      hasUnread={hasUnread}
    >
      <MessagesNavigationContent onClose={() => closeOverlay("messages")} />
    </NavigationActivityOverlay>
  );
};
